// src/types/qbank.ts
// Mirror of QBank `Models.Json.Wallet` (camelCase wire format, no envelope).
// IMPORTANT: the Wallet has NO `model` field (that lives on Coin). An EXP coin
// is identified by a non-null `level` / `toNextLevel`. Hand-kept in sync with
// QBank/Models.cs:99-123 (owned by Gionko).
export interface Wallet {
  currencyId: string;
  sub: string;
  name: string;
  code: string;
  exchange: number | null;
  isDefault: boolean | null;
  amount: number | null;
  defaultCoin: number | null;
  isEnable: boolean | null;
  /** EXP coins only (model=1). null for currency coins (model=0). */
  level: number | null;
  /** EXP coins only — points to the next level. */
  toNextLevel: number | null;
}

/**
 * Display fallback for an entitled user who has no currency wallet yet. QBank
 * creates wallet rows lazily (only on first credit/transfer), so an uncredited
 * user's `GET /wallets/get` returns `[]` — there's no coin to read a code from.
 * We still want a zero balance visible, so the Hub/Profile fall back to this
 * default coin and render "0 QC". Replace if the platform's default coin changes.
 */
export const QBANK_DEFAULT_COIN = { code: 'QC', name: 'QLASH Coin' } as const;
